// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.1@core-js/library/modules/_enum-bug-keys.js
// module id = 130
// module chunks = 0 1